<template>
  <div>
    <TaxPaymentReportComp />

  </div>
</template>

<script>
import TaxPaymentReportComp from '../../../components/tax/payments/Reports/TaxPaymentReportComp.vue';

export default {
  name: 'TaxPaymentReport',
  components: {
    TaxPaymentReportComp,
  },
};

</script>
